import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  apiDocsContainer: {
    width: "100%",
    minHeight: "100vh",
    overflow: "auto",
  },
}));

export function ApiDocsPage() {
  const classes = useStyles();

  useEffect(() => {
    const existingScript = document.querySelector('script[src*="swagger-ui"]');
    if (!existingScript) {
      const swaggerUiScript = document.createElement("script");
      swaggerUiScript.src = "https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui-bundle.js";
      swaggerUiScript.onload = () => {
        const presetScript = document.createElement("script");
        presetScript.src = "https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui-standalone-preset.js";
        presetScript.onload = initializeSwaggerUI;
        document.body.appendChild(presetScript);
      };
      document.body.appendChild(swaggerUiScript);
    } else {
      initializeSwaggerUI();
    }
  }, []);

  const initializeSwaggerUI = () => {
    if (window.SwaggerUIBundle && !document.querySelector(".swagger-ui")) {
      window.SwaggerUIBundle({
        url: "/swagger/swagger.json",
        dom_id: "#swagger-ui",
        deepLinking: true,
        presets: [
          window.SwaggerUIBundle.presets.apis,
          window.SwaggerUIStandalonePreset,
        ],
        layout: "StandaloneLayout",
        plugins: [
          window.SwaggerUIBundle.plugins.DownloadUrlPlugin,
        ],
        defaultModelsExpandDepth: 1,
        defaultModelExpandDepth: 1,
        docExpansion: "list",
        filter: true,
        showExtensions: true,
        showCommonExtensions: true,
        displayRequestDuration: true,
        tryItOutEnabled: true,
      });
    }
  };

  return (
    <div className={classes.apiDocsContainer} style={{ padding: 0, margin: 0 }}>
      <style>{`
        #swagger-ui {
          min-height: 100vh;
        }
        #swagger-ui .swagger-ui {
          max-width: 100%;
        }
      `}</style>
      <link
        rel="stylesheet"
        type="text/css"
        href="https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui.css"
      />
      <div id="swagger-ui" />
    </div>
  );
}

export default ApiDocsPage;